module.exports = __webpack_public_path__ + "img/PRNT_02_mono_AE_00003.23df5778.png";